import React from 'react';

const StatusEditDialog = ({ open, onClose, user, statusData, setStatusData, onSubmit }) => {
  const statusOptions = ['Active', 'Suspended', 'Banned', 'Deleted'];

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Dialog */}
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
          {/* Header */}
          <div className="bg-gray-50 px-6 py-4 border-b">
            <h3 className="text-lg font-semibold text-gray-900">Update User Status</h3>
          </div>

          {/* Content */}
          <div className="px-6 py-4 space-y-4">
            <div className="space-y-1">
              <p className="text-sm text-gray-600">User: {user?.email}</p>
              <p className="text-sm text-gray-600">
                Current Status: <span className="font-medium">{user?.status}</span>
              </p>
            </div>

            {/* Status Select */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Status
              </label>
              <select
                value={statusData.status}
                onChange={(e) => setStatusData({ ...statusData, status: e.target.value })}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-btn-primary/50 focus:border-btn-primary"
              >
                <option value="">Select Status</option>
                {statusOptions.map((status) => (
                  <option key={status} value={status}>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            {/* Reason Textarea */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Reason for Change
              </label>
              <textarea
                value={statusData.reason}
                onChange={(e) => setStatusData({ ...statusData, reason: e.target.value })}
                rows={4}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-btn-primary/50 focus:border-btn-primary"
                placeholder="Please provide a reason for the status change"
              />
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 border-t flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={onSubmit}
              disabled={!statusData.status || !statusData.reason}
              className={`px-4 py-2 rounded-md text-white
                ${!statusData.status || !statusData.reason
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-btn-primary hover:bg-btn-primary/90 focus:outline-none focus:ring-2 focus:ring-btn-primary/50'
                }`}
            >
              Update Status
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusEditDialog;